/**
 * 严肃声明：
 * 开源版本请务必保留此注释头信息，若删除我方将保留所有法律责任追究！
 * 本系统已申请软件著作权，受国家版权局知识产权以及国家计算机软件著作权保护！
 * 可正常分享和学习源码，不得用于违法犯罪活动，违者必究！
 * Copyright (c) 2020 陈尼克 all rights reserved.
 * 版权所有，侵权必究！
 */

import axios from '../utils/axios'

// 获取详情数据
export function getDetails(params) {
    return axios.post('/trace_product/QTraceProductApi', params);
}

// 获取列表数据
export function getList(params) {
    return axios.get('/traceability/QTraceabilityApi', { params });
}

